"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const react_checkbox_1 = require("@radix-ui/react-checkbox");
const __1 = require("../../..");
const Checkbox_styles_1 = require("./Checkbox.styles");
/**
 * @deprecated please use <Ds.Checkbox> instead
 */
const Checkbox = (_a) => {
    var { id, disabled, text, theme = "traditional", size = "medium", checked, onCheckChange, children } = _a, props = __rest(_a, ["id", "disabled", "text", "theme", "size", "checked", "onCheckChange", "children"]);
    return (react_1.default.createElement(Checkbox_styles_1.StyledCheckboxWrapper, Object.assign({ theme: theme, disabled: disabled, "$size": size, "$checked": checked }, props),
        react_1.default.createElement(__1.Text, { as: "label", skinny: true, props: {
                htmlFor: id,
                className: "custom-checkbox-label",
                disabled: { disabled },
                $checked: { checked },
            } },
            react_1.default.createElement(Checkbox_styles_1.StyledCheckboxRoot, { checked: checked, onCheckedChange: onCheckChange, id: id, disabled: disabled, "aria-label": text },
                react_1.default.createElement(react_checkbox_1.Indicator, null, react_1.default.createElement(__1.Icon, { colour: "white", name: "Tick", size: 2 }))),
            react_1.default.createElement(Checkbox_styles_1.StyledInnerText, null,
                children,
                !children && text && react_1.default.createElement(react_1.default.Fragment, null, text)))));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map